import React, { useState, useEffect } from "react";
import './AboutCard.css';
import axios from "axios";

function AboutCard() {
  const [CardSection, setCardSection] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/vision_list"
      );
      setCardSection(response.data.data);
    };

    fetchData();
  }, []);

  return (
    <>
      <section className="offer-section">
        <figure className="offer-toplayer mb-0">
          <img
            src="about-img/offer-toplayer.png"
            alt=""
            className="img-fluid"
          />
        </figure>
        <div className="container">
          <div className="row position-relative">
            {CardSection.map((Data, index) => (
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 article_padding" key={index}>
                <div className="offer_boxcontent" style={{ padding: "50px" }}>
                  <div className="upper_portion">
                    <div className="article_img">
                      <figure className="mb-0">
                        <img src={`https://cyberathon.com/NLF/${Data.vis_image}`} alt="vision-img" />
                      </figure>
                    </div>
                    <div className="image_content">
                      <figure className="offer-icon">
                        <img
                          src={`https://cyberathon.com/NLF/${Data.vis_logo}`}
                          alt="vision logo"
                          className="img-fluid"
                        />
                      </figure>
                    </div>
                  </div>
                  <div className="lower_portion_wrapper">
                    <div className="lower_portion">
                      <h4 className="mb-0">{Data.vis_heading}</h4>

                      <p dangerouslySetInnerHTML={{ __html: Data.vis_paragraph }}>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <figure className="offer-bottomlayer mb-0">
          <img
            src="about-img/offer-bottomlayer.png"
            alt=""
            className="img-fluid"
          />
        </figure>
      </section>
    </>
  );
}

export default AboutCard;
